//#region recipes/conversation_view/feed_item_row/feed_item_row_constants.js
var e = {
	NORMAL: "",
	SEARCHED: "d-recipe-feed-item-row__state--searched",
	ERROR: "d-recipe-feed-item-row__state--error"
}, t = "NORMAL", n = {
	FEED_ROW_STATE_BACKGROUND_COLOR: e,
	DEFAULT_FEED_ROW_STATE: t
};
//#endregion
export { t as DEFAULT_FEED_ROW_STATE, e as FEED_ROW_STATE_BACKGROUND_COLOR, n as default };

//# sourceMappingURL=feed-item-row-constants.js.map